<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M2.02967 4.79999L11.0687 13.236C11.5911 13.7232 12.4088 13.7232 12.9312 13.236L21.9702 4.79999H2.02967ZM0.799988 5.84062V19.2001H23.1999V5.84062L14.0234 14.4063C13.4562 14.9359 12.728 15.2 12 15.2C11.272 15.2 10.5437 14.9359 9.97652 14.4063L0.799988 5.84062Z" fill="#000000"/>
</svg>
